__turbopack_context__.v({
  "active": "_3WXTza_active",
  "cta": "_3WXTza_cta",
  "environments": "_3WXTza_environments",
  "hamburger": "_3WXTza_hamburger",
  "header": "_3WXTza_header",
  "high-contrast": "_3WXTza_high-contrast",
  "logo": "_3WXTza_logo",
  "main-navigation": "_3WXTza_main-navigation",
  "my-bolt": "_3WXTza_my-bolt",
  "small-bar": "_3WXTza_small-bar",
});
